import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  GET_PORTAL_VERSION_REQUEST: '',
  GET_PORTAL_VERSION_SUCCESS: '',
  GET_PORTAL_VERSION_FAILURE: '',

  GET_PORTAL_CONTACT_REQUEST: '',
  GET_PORTAL_CONTACT_SUCCESS: '',
  GET_PORTAL_CONTACT_FAILURE: '',
};

types = setStoreTypeValues(types, 'appPortal');

export default types;
